import SortingOption from './bootstrap-table-sorting-option';

export const sortingFunction = (
    data: any[],
    sortingOption: SortingOption,
    nullsAndEmptyAtBottom?: boolean,
    countZeroAsEmpty?: boolean
) => {
    const sortedData = data.sort((a, b) => {
        const aValue = getNestedValue(a, sortingOption.dataField);
        const bValue = getNestedValue(b, sortingOption.dataField);

        const order = sortingOption.order === 'asc' ? 1 : -1;

        if (nullsAndEmptyAtBottom !== null) {
            const aValueIsEmpty = isEmptyValue(aValue, countZeroAsEmpty);
            const bValueIsEmpty = isEmptyValue(bValue, countZeroAsEmpty);
            const nullComparison = handleNulls(
                aValueIsEmpty,
                bValueIsEmpty,
                nullsAndEmptyAtBottom || countZeroAsEmpty
            );
            if (nullComparison !== null) {
                return nullComparison;
            }
        }

        if (isValidDate(aValue) && isValidDate(bValue)) {
            return order * dateComparation(aValue, bValue);
        }

        if (isNumber(aValue) && isNumber(bValue)) {
            return order * numberComparation(aValue, bValue);
        }

        if (typeof aValue === 'boolean' && typeof bValue === 'boolean') {
            return order * numberComparation(Number(aValue), Number(bValue));
        }

        return order * stringComparation(aValue, bValue);
    });

    return sortedData;
};

const stringComparation = (a: any, b: any) => {
    if (a === null || a === undefined) return -1;
    if (b === null || b === undefined) return 1;
    return String(a).localeCompare(String(b));
};

const numberComparation = (a: number, b: number) => {
    if (a === null || a === undefined) return -1;
    if (b === null || b === undefined) return 1;
    return a - b;
};

const dateComparation = (a: string | null, b: string | null) => {
    if (a === null || a === undefined) return -1;
    if (b === null || b === undefined) return 1;
    return new Date(a).getTime() - new Date(b).getTime();
};

const isValidDate = (date: any) => {
    if (date === null || date === undefined) return false;
    const parsedDate = Date.parse(date);
    return !isNaN(parsedDate);
};

const isNumber = (value: any) => {
    return !isNaN(value) && typeof value === 'number';
};

const handleNulls = (
    aValueIsNull: boolean,
    bValueIsNull: boolean,
    nullsAtBottom: boolean
) => {
    if (aValueIsNull && bValueIsNull) return 0;
    if (aValueIsNull) return nullsAtBottom ? 1 : -1;
    if (bValueIsNull) return nullsAtBottom ? -1 : 1;
    return null;
};

const isEmptyValue = (value: any, countZeroAsEmpty?: boolean): boolean => {
    return (
        value === null ||
        value === undefined ||
        value === '' ||
        (countZeroAsEmpty && value === 0)
    );
};

const getNestedValue = (obj: any, path: string) => {
    if (!path) return undefined;
    return path
        .split('.')
        .reduce(
            (currentObject, propertyName) =>
                currentObject && currentObject[propertyName],
            obj
        );
};
